import React from 'react'
import type { IconProps } from './index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const FontAwesome6Icon = ({ name, type: _type, style: _style, rotation: _rotation, ...rest }: IconProps) => {
  return <FontAwesomeIcon icon={name as any} {...rest} />
}
